import { LinkedinIcon } from '../icons/social/LinkedinIcon'
import { FacebookIcon } from '../icons/social/FacebookIcon'
import { InstagramIcon } from '../icons/social/InstagramIcon'
import type { SvgIconProps } from '../icons/svgIcon'
import { Link } from 'react-router-dom'

type Brand = 'linkedin' | 'facebook' | 'instagram'

const hrefByBrand: Record<Brand, string> = {
  linkedin: 'https://www.linkedin.com/company/invest-in-slovakia',
  instagram: 'https://www.instagram.com/investinslovakia/',
  facebook: 'https://www.facebook.com/investinslovakia',
}

const logoByBrand: Record<Brand, (props: SvgIconProps) => React.ReactNode> = {
  linkedin: LinkedinIcon,
  facebook: FacebookIcon,
  instagram: InstagramIcon,
}

interface Props {
  brand: 'linkedin' | 'facebook' | 'instagram'
}

export const SocialLogoLink = ({ brand }: Props) => {
  const Icon = logoByBrand[brand]
  const href = hrefByBrand[brand]

  return (
    <Link to={href} target="_blank" rel="noreferrer noopener nofollow">
      <Icon width={20} height={20} />
    </Link>
  )
}
